/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import { AppProps } from 'next/app';
import '@doda/common/src/styles/Base.scss';
import '@doda/common/src/styles/Slick.scss';
import '@doda/io-react/common/index.css';
import { isNodeProd } from '@doda/common/src/utils/envUtil';
import { initDatadogBrowserLogs } from '@doda/common/src/libs/datadog/browser-logs';
import { RootApp } from '@doda/common/src/components/RootApp';

/**
 * 上位コンポーネント
 * @remarks
 * 全てのコンポーネントがAppコンポーネントを継承する
 * 全ページで共通して実行させたい処理やレイアウトはRootAppコンポーネントを更新してください。
 * @param Component コンポーネント
 * @param pageProps ページプロパティ
 * @returns Appコンポーネント
 */
const App: FC<AppProps> = ({ Component, pageProps }) => {
  if (isNodeProd) {
    initDatadogBrowserLogs({
      isSmartphone: false,
    });
  }

  return (
    <RootApp>
      <Component {...pageProps} />
    </RootApp>
  );
};

export default App;
